import Home from "../Home/Index";
import { FundoGradiente } from "../Styles/globalStyled";

const AboutMe: React.FC = () => {
  return (
    <FundoGradiente>
      <Home />
    </FundoGradiente>
  );
};
export default AboutMe;
